import React, { useCallback, useMemo } from 'react'
import { Table, Button, Modal, Tooltip } from 'antd'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'
import CONFIG from '../../../constants/config'
import * as WM from '../typings'
import WatermarkCover from './components/WatermarkCover'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { deleteStorage } from '../lib/draft'
import { draftWatermarksAction } from '../../../actions/watermark'
import { QuestionCircleOutlined } from '@ant-design/icons'

const Column = Table.Column

const Unpublished: React.FC<WM.UnpublishedProps> = ({ keyword }) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const groupID = useAppSelector((state) => state.group.groupId)
  const draftWatermarkList = useAppSelector(
    (state) => state.watermark.draftWatermarkList
  )
  const fetchWatermarks = useCallback(() => {
    dispatch(draftWatermarksAction(groupID))
  }, [groupID])

  const dataSource: WM.Watermark[] = useMemo(() => {
    return draftWatermarkList
      .map((watermark) => {
        if (watermark.watermarkContent) {
          return watermark
        } else {
          let watermarkContent = null
          try {
            watermarkContent = JSON.parse(watermark.content)
          } catch (err) {
            console.log('水印信息解析失败，数据错误，水印ID：' + watermark.id)
          }
          return {
            ...watermark,
            watermarkContent
          }
        }
      })
      .filter((watermark: WM.Watermark) => {
        if (keyword.trim()) {
          return (
            watermark.watermarkContent &&
            watermark.watermarkContent.name?.includes(keyword.trim())
          )
        } else {
          return true
        }
      })
  }, [draftWatermarkList, keyword])

  const onEdit = useCallback(
    (watermarkID) => {
      navigate(
        '/watermark/editor?action=modify&is_draft=1&watermark_id=' + watermarkID
      )
    },
    [navigate]
  )

  const onDeleteClick = (watermark) => {
    Modal.confirm({
      title: '确认要删除这个模板吗？',
      onOk: () => {
        deleteStorage(watermark.id, groupID)
        fetchWatermarks()
      }
    })
  }
  return (
    <Table dataSource={dataSource} rowKey="id" pagination={false}>
      <Column
        width="20%"
        align="center"
        title="封面图"
        key="cover"
        render={(record: WM.Watermark) => <WatermarkCover watermark={record} />}
      />
      <Column
        width="20%"
        title="模板名称"
        dataIndex={['watermarkContent', 'name']}
      />
      <Column
        align="center"
        width="20%"
        title="创建时间"
        dataIndex="createTime"
        render={(text: string) =>
          dayjs(parseInt(text)).format(CONFIG.photoTimeFormat)
        }
      />
      <Column title="使用范围" render={() => <span>-</span>} />
      <Column
        width="15%"
        title="操作"
        render={(record: WM.Watermark) => {
          if (record.watermarkContent?.base_id === '34') {
            return (
              <Tooltip title="时间地点天气类水印暂不支持编辑，请使用手机客户端进行编辑。">
                <span>
                  <QuestionCircleOutlined />
                </span>
              </Tooltip>
            )
          } else {
            return [
              <Button
                style={{ paddingLeft: 0 }}
                key="edit"
                type="link"
                disabled={!record.watermarkContent}
                onClick={() => onEdit(record.id)}
              >
                编辑
              </Button>,
              <Button
                style={{ color: '#EB524A' }}
                key="delete"
                type="link"
                onClick={() => onDeleteClick(record)}
              >
                删除
              </Button>
            ]
          }
        }}
      />
    </Table>
  )
}

export default Unpublished
